@if (showOlimpia()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
    <div class="relative w-full h-full">
      <iframe
        [src]="validationOlimpiaUrl"
        class="w-full h-full border-none"
        allow="camera; microphone; fullscreen">
      </iframe>
    </div>
  </div>
}

@if (showError()) {
    <app-error-screen
        [title]="titleError"
        (close)="retry()"
        [description]="descriptionError">
    </app-error-screen>
}

@if (wowDisplay()) {
  <app-wow (completed)="next()"></app-wow>
}
